import { Alert, Box, Button, Container, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import ClpTable from "components/ClpTable"
import { ClpTableEnum } from "components/ClpTable/ClpTableEnum"
import { StyledTableContainer } from "shared/styled/Global"
import PayslipLoadError from "./PayslipLoadError"
import { usePayslip } from "./usePayslip"

const Payslip = () => {
  const { listPayslipsResult, downloadFailed, downloadPayslip, loadPayslips } = usePayslip()
  const { t } = useTranslation()

  const columns = [
    {
      accessorKey: "salaryPeriodName",
      header: "Period"
    },
    {
      accessorKey: "salaryPeriodPaymentDate",
      header: "Utbetalningsdag"
    },
    {
      id: "download",
      header: "",
      meta: {
        align: "right"
      },
      cell: ({ cell }) => {
        const payslip = cell.row.original
        return (
          <Button
            size="small"
            variant="outlined"
            disabled={!payslip.pdfStr}
            onClick={() => {
              downloadPayslip(payslip)
            }}>
            {t("global.buttons.download", "Download")}
          </Button>
        )
      }
    }
  ]

  return (
    <div>
      <Container>
        <Box>
          <Typography variant="h1">{t("global.payslip", "Payslip")}</Typography>
        </Box>
      </Container>
      {downloadFailed && (
        <Container>
          <Alert severity="error">
            {t("payslip.download_failed", "Could not download the payslip. Please try again.")}
          </Alert>
        </Container>
      )}
      <StyledTableContainer>
        <ClpTable
          rows={listPayslipsResult?.data?.entity || []}
          loadingState={listPayslipsResult.status}
          columns={columns}
          tableId={ClpTableEnum.Payslips}
        />
      </StyledTableContainer>
      {listPayslipsResult.status === 3 && (
        <PayslipLoadError messages={listPayslipsResult.messages} onRetry={loadPayslips} />
      )}
    </div>
  )
}

export default Payslip
